/**
 * Convert an object to a URL query string
 * @param object - The object to convert
 * @param sep - Separator between key-value pairs (default: '&')
 * @param eq - Separator between key and value (default: '=')
 * @returns URL-encoded query string
 */
export const toQueryString = (object: Record<string, any>, sep = '&', eq = '='): string => {
    if (!object || typeof object !== 'object') {
        return ''
    }

    const pairs: string[] = []
    
    for (const [key, value] of Object.entries(object)) {
        if (value !== null && value !== undefined && value !== '') {
            const encodedKey = encodeURIComponent(key)
            const encodedValue = encodeURIComponent(String(value))
            pairs.push(`${encodedKey}${eq}${encodedValue}`)
        }
    }
    
    return pairs.join(sep)
}
